import React from 'react';

import { GoShield } from "react-icons/go";
import { FaCrown, FaUserAlt } from "react-icons/fa";

export const rolesList = [
    {
        name: "admin",
        description: "Puede convertir a otros en admin y eliminar recursos",
        canDo: "administrar variables técnicas y al staff; ejecutar procesos; descargar archivos y visualizar.",
        iconComponent: <FaCrown />
    },
    {
        name: "staff",
        description: "Puede ejecutar procesos y descargar archivos generados",
        canDo: "administrar al staff, ejecutar procesos; descargar archivos y visualizar.",
        iconComponent: <GoShield />
    },
    {
        name: "lector",
        description: "Puede visualizar reportes y estados de última descarga",
        canDo: "visualizar la información de la plataforma.",
        iconComponent: <FaUserAlt />
    }
]

export const getCanDoBasedOnPermissions = (targetUser, canWord = "Puede") => {
    if (targetUser.is_admin)
        return canWord + " " + rolesList[0].canDo;

    if (targetUser.is_staff)
        return canWord + " " + rolesList[1].canDo;

    if (targetUser.is_active)
        return canWord + " " + rolesList[2].canDo;

    return "No tiene acceso a la plataforma";
}
